import(/* webpackMode: "eager" */ "C:\\xampp\\htdocs\\mykonya\\src\\app\\not-found.tsx");
